import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { authReducer, AuthState } from '../../auth/store/reducers/auth.reducer';
import {
  currencyReducer,
  CurrencyState,
} from '../../currency/store/reducers/currency.reducer';
import {
  localeReducer,
  LocaleState,
} from '../../locale/store/reducers/locale.reducer';
import {
  loyaltyCurrencyReducer,
  LoyaltyCurrencyState,
} from '../../loyalty-currency/store/reducers/loyalty-currency.reducer';
import {
  tenantReducer,
  TenantState,
} from '../../tenant/store/reducers/tenant.reducer';
import {
  userCustomizationsReducer,
  UserCustomizationsState,
} from '../../user-customizations/store/reducers/user-customizations.reducer';

export interface CoreState {
  auth: AuthState;
  currency: CurrencyState;
  locale: LocaleState;
  loyaltyCurrency: LoyaltyCurrencyState;
  tenant: TenantState;
  userCustomizations: UserCustomizationsState;
}

// TODO: fix later
export const reducers: ActionReducerMap<CoreState> = {
  // @ts-ignore
  auth: authReducer,
  // @ts-ignore
  currency: currencyReducer,
  // @ts-ignore
  locale: localeReducer,
  // @ts-ignore
  loyaltyCurrency: loyaltyCurrencyReducer,
  // @ts-ignore
  tenant: tenantReducer,
  // @ts-ignore
  userCustomizations: userCustomizationsReducer,
};

export const getCoreState = createFeatureSelector<CoreState>('core');
